import { Charger, DistinctConnectors } from '../../core/models';
import ChargerConnectorInfo from './ChargerConnectorInfo';

interface Props {
  distinctConnectors: DistinctConnectors;
  chargerInfo: Charger;
}

export default function ChargerEVSEInfo({ distinctConnectors, chargerInfo }: Props) {
  return (
    <div className="charger-evse">
      <ChargerConnectorInfo connector={distinctConnectors} chargerInfo={chargerInfo} />
    </div>
  );
}
